import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import { useHydrated } from '../hooks/useHydrated';
import { useTranslation } from '../hooks/useTranslation';
import './NotFound.css';

const NotFound = () => {
  const hydrated = useHydrated();
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <SEO
        title="Page Not Found"
        description="The page you are looking for does not exist. Return to AstroEpanchang for Vedic astrology, Panchangam, horoscopes, and more."
        noindex={true}
      />
      <div className="container">
        <motion.div
          className="not-found-content"
          initial={hydrated ? { opacity: 0, y: 20 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="not-found-icon">404</div>
          <h1>{t('common.pageNotFound') || 'Page Not Found'}</h1>
          <p>{t('common.pageNotFoundDesc') || 'The page you are looking for might have been moved, deleted, or does not exist.'}</p>
          <div className="not-found-links">
            <Link to="/" className="btn btn-primary">
              {t('common.backToHome') || 'Back to Home'}
            </Link>
            <Link to="/horoscope" className="btn btn-secondary">
              {t('common.viewHoroscope') || 'View Horoscope'}
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
